// extracted by mini-css-extract-plugin
export var card = "_n0-0";
export var content = "_n0-2";
export var details = "_n0-3";
export var icon = "_n0-1";
export var iconBlue = "_n0-5";
export var iconBrand = "_n0-4";
export var iconGrayBlue = "_n0-6";
export var iconGreen = "_n0-7";
export var iconIndigo = "_n0-8";
export var iconOrange = "_n0-9";
export var iconPurple = "_n0-a";
export var iconRed = "_n0-b";
export var iconWarning = "_n0-c";